import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=52ca26bd&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca26bd",
  null
  
)

export default component.exports